import { NgModule }            from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import {TranslateModule} from "../../translate-module";
import { TextMaskModule } from 'angular2-text-mask';
import { NPCPageComponent } from "./npc-modal-component";
import { ShopPageComponent } from "./shop-modal-component";
import { MediaPageComponent } from "./media-modal-component";



@NgModule({
    imports : [
        ReactiveFormsModule,
        CommonModule,
        TranslateModule,
        TextMaskModule,
    ],
    declarations : [
        NPCPageComponent,
        ShopPageComponent,
        MediaPageComponent
    ],
    exports:[
        NPCPageComponent,

    ],
    providers : [
    ]
})
export class ModalModule {}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/Modals/modal.module.ts